/**
 * Menu toggle
 */
$('#js-toggle-nav').click(function() {
    $(this).toggleClass('is-toggled');
    $('.mobile-menu').toggleClass('is-toggled');
    $('body').toggleClass('no-scroll  menu-open');
    $('html').toggleClass('no-scroll');
    $('.site-main').toggleClass('no-scroll');

    //target the entire page, and listen for touch events
    $('.mobile-menu').on('touchmove', function(e){
        //prevent native touch activity like scrolling
        e.preventDefault();
    });
});

/**
 * Dropdown
 */
$('.js-dropdown').on('click', function (event) {
    var dropdown = $(this);
    var target = $(event.target);

    if (dropdown.hasClass('is-open')) {
        if (target.closest('.select-multiple-header').length) {
            // Close this dropdown
            dropdown.removeClass('is-open');
            event.stopPropagation();
        }

        return;
    }

    // Close all other dropdowns and open this one
    $('.js-dropdown').not(this).removeClass('is-open');
    dropdown.addClass('is-open');
    event.stopPropagation();
});

$('html').on('click', function (event) {
    if ($(event.target).closest('.js-dropdown').length === 0) {
        // Close all open dropdowns
        $('.js-dropdown.is-open').each(function (index, element) {
            $(element).removeClass('is-open');
        });
    }
});

/**
 * Readmore
 */
if ($(window).width() <= 767) {
    $('.article').readmore({
        speed: 75,
        moreLink: '<a style="text-transform: uppercase; font-size: .875rem;" href="#">Läs mer om jobbet </a>',
        embedCSS: false,
        lessLink: false
    });
}

$('body').on('click', '.js-toggle', toggle);

function toggle(event) {
    var modal = $(this).closest('.modal');

    modal.find('.js-toggle').not(this).removeClass('is-toggled');

    if (!$(this).hasClass('is-toggled')) {
        $(this).toggleClass('is-toggled');
    }
}

/**
 * Vex
 */
(function (window, $) {
    $('body').on('click', '[data-show-modal]', showShareModal);
    $('body').on('click', '[data-show-candidate-modal]', showCandidateModal);
    $('body').on('click', '[data-show-employee-modal]', showEmployeeModal);
    $('body').on('click', '[data-show-sales-company-modal]', showSalesCompanyModal);
    $('body').on('click', '[data-show-schedule-slot-modal]', showScheduleSlotModal);

    function showShareModal(event) {
        vex.open({
            content: $('#show-modal').clone().removeAttr('id').show(),
            className: 'vex-theme-default',
            closeClassName: 'close',
            afterOpen: function (vexContent) {
                vexContent.find('form').attr('id', 'email-sharer-form');
                vexContent.find('#living-location-typeahead-template').attr('id', 'living-location-typeahead');
                vexContent.find('#hidden-location-id-template').attr('id', 'hidden-location-id');
                vexContent.find('#register-password-template').attr('id', 'register-password');
                $('#living-location-typeahead-template').trigger('cloned');
                $('#county').trigger('vex-cloned');
            }
        });
    }

    function showCandidateModal(event) {
        var candidateId = $(this).data('show-candidate-modal');
        var candidateModal = $('#show-candidate-modal-template-' + $(this).data('show-candidate-modal'));
        var candidateModal = candidateModal.clone().attr('id', 'show-candidate-modal-' + candidateId).show();

        vex.open({
            content: candidateModal,
            className: 'vex-theme-default',
            closeClassName: 'close'
        });
    }

    function showEmployeeModal(event) {
        var employeeId = $(this).data('show-employee-modal');
        var employeeModal = $('#show-employee-modal-template-' + $(this).data('show-employee-modal'));
        var employeeModal = employeeModal.clone().attr('id', 'show-employee-modal-' + employeeId).show();

        vex.open({
            content: employeeModal,
            className: 'vex-theme-default',
            closeClassName: 'close'
        });
    }

    function showSalesCompanyModal(event) {
        var companyId = $(this).data('show-sales-company-modal');
        var salesCompanyModal = $('#show-sales-company-modal-template-' + $(this).data('show-sales-company-modal'));
        var salesCompanyModal = salesCompanyModal.clone().attr('id', 'show-sales-company-modal-' + companyId).show();

        vex.open({
            content: salesCompanyModal,
            className: 'vex-theme-default',
            closeClassName: 'close'
        });
    }

    function showScheduleSlotModal(event) {
        var inputValue = $(this).data('show-schedule-slot-modal');
        var id = '#show-schedule-slot-modal-template-' + inputValue;
        var scheduleSlotModal = $(id);
        var scheduleSlotModal = scheduleSlotModal.clone().attr('id', 'show-schedule-slot-modal-' + inputValue).show();

        vex.open({
            content: scheduleSlotModal,
            className: 'vex-theme-default',
            closeClassName: 'close'
        });
    }

})(window, jQuery);

if ($('#locations-typeahead').length) {
    var locations = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        prefetch: {
            url: $('#locations-typeahead').attr('data-prefetch-url'),
            ttl: 60
        }
    });

    locations.initialize();

    $('#locations-typeahead').tagsinput({
        typeaheadjs: {
            name: 'locations',
            displayKey: 'name',
            valueKey: 'name',
            source: locations.ttAdapter()
        }
    });
}

(function ($, window) {
    var cookieUsageElement = $('#cookie-usage-element');
    var cookieUsageAccept = $('#cookie-usage-accept');

    viwebb.cookie.acceptCookieUsage(cookieUsageElement, cookieUsageAccept);
})(jQuery, window);

/**
 * This function will replace the typeahead and reuse the data collected from the locations endpoint to build a two tier
 * select, where the first tier is the county and second tier is the municipality. This way we get rid of the problem of
 * people not understanding how a typeahead works, but keep the selects option length to a minimum.
 *
 * As stated above, this function reuses the data from the locations index page without changes to the back end. It uses
 * pattern matching to build two lists, each containing either counties or minicipalities. The municipalities gets an ID
 * matching the ID of its parent. When county is changed, the municipalities options are rewritten to match that parent.
 *
 * Municipalities are called "locations" to match the expected input for the form.
 */
(function ($, window) {
    if ($('#county').length <= 0 || $('#location-placeholder').length <= 0) {
        return;
    }

    var counties = [];
    var municipalities = [];
    var currentLocation = 0;
    var currentCounty = 0;

    function getLocationInformation() {
        $.ajax({
            type: 'get',
            url: $('#county').attr('data-url'),
            success: function (data) {
                $(data).each(function () {
                    if (this.full_name.indexOf(' - ') == -1) {
                        counties.push(this);
                    }

                    if (this.full_name.indexOf(' - ') !== -1) {
                        municipalities.push(this);
                    }
                });

                $(municipalities).each(function () {
                    var municipality = this;

                    $(counties).each(function () {
                        var county = this;

                        if (municipality.full_name.indexOf(county.name) !== -1) {
                            municipality.parent = county.id;
                        }
                    });
                });

                var hiddenLocation = $('input[name=location]');

                if (hiddenLocation.val()) {
                    currentLocation = hiddenLocation.val();
                }

                hiddenLocation.remove();

                if (currentLocation > 0) {
                    $(municipalities).each(function () {
                        var municipality = this;

                        if (municipality.id == currentLocation) {
                            currentCounty = municipality.parent;
                            return false;
                        }
                    });
                }

                $('#county').trigger('location-data-acquired');
            }
        });
    }

    function setLocationSelectOptions() {
        if ($('.js-registration-modal-body').length > 0) {
            var modalBody = $('.js-registration-modal-body');

            modalBody.find('#location-placeholder').attr('id', 'location').attr('name', 'location');
            modalBody.find('label[for=location-placeholder]').attr('for', 'location');

            var countySelect = modalBody.find('#county');
            var locationSelect = modalBody.find('#location');
        } else {
            $('#location-placeholder').attr('id', 'location').attr('name', 'location');
            $('label[for=location-placeholder]').attr('for', 'location');

            var countySelect = $('#county');
            var locationSelect = $('#location');
        }

        $(counties).each(function () {
            if (currentCounty !== 0 && this.id == currentCounty) {
                countySelect.append('<option value="' + this.id + '" selected>' + this.name + '</option>');
            } else {
                countySelect.append('<option value="' + this.id + '">' + this.name + '</option>');
            }
        });

        if (countySelect.val() > 0) {
            countySelect.find('option[value="0"]').remove();

            locationSelect.find('option').remove();

            if (currentLocation == 0) {
                locationSelect.append('<option value="0">Välj din kommun...</option>');
                locationSelect.on('change', function () {
                    $(this).find('option[value="0"]').remove();
                });
            }

            $(municipalities).each(function () {
                if (this.parent == countySelect.val()) {
                    if (currentLocation !== 0 && this.id == currentLocation) {
                        locationSelect.append('<option value="' + this.id + '" selected>' + this.name + '</option>');
                    } else {
                        locationSelect.append('<option value="' + this.id + '">' + this.name + '</option>');
                    }
                }
            });

            locationSelect.closest('.form-group').show();
        }

        countySelect.on('change', function () {
            var parentCounty = $(this);

            parentCounty.find('option[value="0"]').remove();

            locationSelect.find('option').remove();
            locationSelect.append('<option value="0">Välj din kommun...</option>');

            $(municipalities).each(function () {
                if (this.parent == parentCounty.val()) {
                    locationSelect.append('<option value="' + this.id + '">' + this.name + '</option>');
                }
            });

            locationSelect.on('change', function () {
                $(this).find('option[value="0"]').remove();
            });

            locationSelect.closest('.form-group').show();
        });
    }

    getLocationInformation();

    if ($('.js-registration-modal-body').length > 0) {
        $('#county').on('location-data-acquired', function () {
            $('#county').on('vex-cloned', setLocationSelectOptions);
        });
    } else {
        $('#county').on('location-data-acquired', setLocationSelectOptions);
    }
})(jQuery, window);
